import type { ApiEndpoints } from '../enums/ApiEndpoints';
import type { PathParams } from '../types/Core';

/**
 * Function to return the API prefix.
 * For now it is fixed, but may be configurable in the future.
 */
export function apiPrefix(): string {
  return '/api/v1/';
}

/**
 * Construct an API URL with an endpoint and (optional) pk value
 */
export function apiUrl(
  endpoint: ApiEndpoints | string,
  pk?: any,
  pathParams?: PathParams
): string {
  let _url = endpoint;

  // If the URL does not start with a '/', add the API prefix
  if (!_url.startsWith('/')) {
    // Server discovery is a framework-level bootstrap dependency, not a
    // commercial OpsTrack resource. Its established endpoint is /api/.
    if (_url === '') {
      _url = '/api/';
    }
    // allauth owns its documented /api/auth/v1 namespace. It is not a
    // second OpsTrack commercial API version.
    else {
      _url = _url.startsWith('auth/v1/') ? `/api/${_url}` : apiPrefix() + _url;
    }
  }

  if (_url && pk) {
    if (_url.indexOf(':id') >= 0) {
      _url = _url.replace(':id', `${pk}`);
    } else {
      _url += `${pk}/`;
    }
  }

  if (_url && pathParams) {
    for (const key in pathParams) {
      _url = _url.replace(`:${key}`, `${pathParams[key]}`);
    }
  }

  return _url;
}
